{
  "version": 1,
  "asset_id": "1828816d-3b05-426a-832a-2a3e888660ca",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/1828816d-3b05-426a-832a-2a3e888660ca/karaoke-37.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/1828816d-3b05-426a-832a-2a3e888660ca/karaoke-37.webp",
  "original_filename": "karaoke-37.webp",
  "size": 189360,
  "content_type": "image/webp",
  "created_at": "2026-10-12T09:41:03Z"
}
